import React from "react";
import "./DealProducts.css";
import product1 from "../components/assets/images/l1.webp";
import product2 from "../components/assets/images/l2.jpg";
import product3 from "../components/assets/images/l3.webp";
import product4 from "../components/assets/images/l4.webp";
import product5 from "../components/assets/images/pro-3.jpg";
import { useCart } from '../components/cart/CartContext';
import { useNavigate } from 'react-router-dom';

const defaultImages = [product1, product2, product3, product4, product5];

const products = [
  {
    id: 1,
    category: "Nutrabay Shudh Himalayan Shilajit/shilajeet Resin From..",
    price: 1349.00,
    oldPrice: 2800.00,
    rating: 4,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 2,
    category: "Neuherbs Pure & Original Himalayan Shilajit / Shilajeet",
    price: 549.00,
    oldPrice: 999.00,
    rating: 3,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 3,
    category: "Neuherbs Shilajit Gold Ultra",
    price: 549.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 4,
    category: "Neuherbs Pure & Original Himalayan Shilajit / Shilajeet",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
  {
    id: 5,
    category: "Neuherbs Pure & Original Himalayan Shilajit / Shilajeet",
    price: 499.00,
    oldPrice: 999.00,
    rating: 2,
    BiParagraph: "Prices are inclusive of all taxes",
  },
];

const StarRating = ({ rating }) => (
  <div className="star-rating">
    {Array(5).fill(0).map((_, i) => (
      <span key={i} className={i < rating ? "filled" : "empty"}>★</span>
    ))}
  </div>
);

export default function DealProducts() {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleBuyNow = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  return (
    <section className="deal-section">
      <div className="deal-header">
        <div>
          <h2 className="deal-title">
            BEST <span className="highlight">SELLERS</span>
          </h2>
          <p className="deal-subtitle">Our Best Selling Premium Quality Ayurvedic Products</p>
        </div>
      </div>

      <div className="product-grid">
        {products.map((product, idx) => {
          const imageSrc = defaultImages[idx % defaultImages.length];

          return (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                <img src={imageSrc} alt={product.category} className="product-image" />
              </div>
              <div className="product-info">
                <p className="category">{product.category}</p>
                <StarRating rating={product.rating} />
                <div className="price-row">
                  <span className="price">₹{product.price.toFixed(2)}</span>
                  <span className="old-price">₹{product.oldPrice.toFixed(2)}</span>
                </div>
                <h3 className="BiParagraph">{product.BiParagraph}</h3>
                <button className="add-to-cart-btn" onClick={() => handleBuyNow(product)}>
                  ADD TO CART
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
